import { Link } from "react-router-dom";
import { getBackgroundClass } from "../../utils/sectionHelpers";
import ServicesCard from "../common/ServicesCard";
import { useLocation } from "react-router-dom";
import SectionTitle from "../common/SectionTitle";

const SolutionsSection = ({ data }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/" || location.pathname === "/home";

  const settings = data?.Settings || {};

  const backgroundClass = getBackgroundClass(settings.background);
  return (
    <>
      <section className={`services-area ptb-70 ${backgroundClass}`}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <SectionTitle data={data} />
            </div>
          </div>

          <div className="row justify-content-center gy-4 gx-lg-5">
            <ServicesCard data={data} />
            {isHomePage && (
              <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                <div className="view-all-solutions">
                  <Link
                    to="#"
                    onClick={(e) => e.preventDefault()}
                    className="default-btn"
                  >
                    <i className="flaticon-right"></i>
                    View All Solutions{" "}
                    <span className="default-btn-hover"></span>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default SolutionsSection;
